/**
 * Agora channel names must be ≤64 bytes (UTF-8) and use only allowed characters.
 * This prevents INVALID_PARAMS when the room name comes from URLs or user paste.
 */
const AGORA_CHANNEL_ALLOWED = /[^a-zA-Z0-9 !#$%&()+\-:;<=>.?@[\]^_{}|~,']/g;
const MAX_BYTES = 64;

function byteLength(str: string): number {
  return new TextEncoder().encode(str).length;
}

export function sanitizeAgoraChannelName(name: string): string {
  if (name == null || typeof name !== 'string') return 'room';
  let s = name.replace(AGORA_CHANNEL_ALLOWED, '').trim();
  // Agora: channel name cannot start with underscore
  while (s.startsWith('_')) s = s.slice(1);
  while (byteLength(s) > MAX_BYTES && s.length > 0) s = s.slice(0, -1);
  return s.length ? s : 'room';
}
